import React, { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

// İlk ekranda görünenler: normal yükle
import Slider2 from "../Components/common/Slider2";
import ThreeBox from "../Components/common/ThreeBox";

// Sayfanın aşağısındaki bölümler: gerektiğinde ayrı chunk
const About = lazy(() => import("../Components/about/About"));
const Projects = lazy(() => import("../Components/project/projects"));
const Question = lazy(() => import("../Components/question/Question"));
const Contactus = lazy(() => import("../Components/contact/Contactus"));

function HomePage() {
  const { i18n } = useTranslation();

  const isEnglish = i18n.language?.startsWith("en");

  const seo = isEnglish
    ? {
        title: "Web Center | Professional Web Design & Digital Solutions",
        description:
          "Web Center provides professional web design, e-commerce, SEO, hosting, corporate email and digital solutions for businesses.",
        keywords:
          "web design, professional web design, e-commerce website, SEO services, web hosting, corporate email, Web Center",
        locale: "en_US",
      }
    : {
        title:
          "Bursa Web Tasarım | Profesyonel Web Sitesi | Web Center",
        description:
          "Web Center; Bursa'da profesyonel web tasarım, e-ticaret, SEO, hosting, kurumsal e-posta ve dijital çözümler sunar. İşletmenize özel web çözümlerini keşfedin.",
        keywords:
          "Bursa web tasarım, web tasarım Bursa, profesyonel web tasarım, web sitesi tasarımı, Bursa web tasarım firması, e-ticaret sitesi, SEO, hosting, Web Center",
        locale: "tr_TR",
      };

  const canonicalUrl = "https://webcenter.com.tr/";

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Web Center",
    url: canonicalUrl,
    logo: "https://webcenter.com.tr/assets/images/logo.webp",
    description: seo.description,
    telephone: "+90-543-405-2825",
    email: "info@webcenter.com.tr",
    address: {
      "@type": "PostalAddress",
      addressLocality: "Nilüfer",
      addressRegion: "Bursa",
      addressCountry: "TR",
    },
    sameAs: [
      "https://www.facebook.com/profile.php?id=61569515864445",
      "https://www.instagram.com/webcenter.office/",
    ],
  };

  return (
    <>
      <Helmet>
        <html lang={isEnglish ? "en" : "tr"} />

        <title>{seo.title}</title>

        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta name="robots" content="index, follow" />

        <link rel="canonical" href={canonicalUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:url" content={canonicalUrl} />
        <meta
          property="og:image"
          content="https://webcenter.com.tr/assets/images/logo.webp"
        />
        <meta property="og:site_name" content="Web Center" />
        <meta property="og:locale" content={seo.locale} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
        <meta
          name="twitter:image"
          content="https://webcenter.com.tr/assets/images/logo.webp"
        />

        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>

      {/* İlk ekran - öncelikli */}
      <Slider2 />
      <ThreeBox />

      {/* İlk ekranın altında kalan bölümler */}
      <Suspense fallback={null}>
        <About />
        <Projects />
        <Question />
        <Contactus />
      </Suspense>
    </>
  );
}

export default HomePage;